import axios from 'axios';
// import { API_BASE_URI } from '../constants';

// ----------------------------------------------------------------------------
// REST API
// ----------------------------------------------------------------------------
const instance = axios.create({
  // baseURL: API_BASE_URI,
  baseURL: global.apiBasePath,
});

const api = (url, method, options) => instance({
  url,
  method,
  ...options,
})
  .then((res) => res.data)
  .catch((error) => {
    if (error.response) {
      if (typeof error.response.data === 'object') {
        return error.response.data;
      }
      throw new Error('errors.something_wrong');
    } else if (error.request) {
      throw new Error('errors.network');
    }
    throw new Error('errors.internal');
  })
  .then((res) => {
    if (res.status === 'success') {
      return res.data;
    }
    throw new Error((res && res.data && res.data.error) || 'errors.something_wrong');
  });

export default {
  api,
  get: (url, params, headers) => api(url, 'GET', { params, headers }),
  post: (url, data, headers) => api(url, 'POST', { data, headers }),
  put: (url, data, headers) => api(url, 'PUT', { data, headers }),
  delete: (url, params, headers) => api(url, 'DELETE', { params, headers }),
};

// import params from 'jquery-param';
// import { API_BASE_URI } from '../constants';
//
// // ----------------------------------------------------------------------------
// // REST API
// // ----------------------------------------------------------------------------
// const api = (path, method, options) => fetch(`${API_BASE_URI}/${path}`, {
//   method,
//   headers: {
//     Accept: 'application/json',
//     'Content-Type': 'application/json',
//   },
//   ...options,
// })
//   .then(r => r.json()
//     .catch((e) => {
//       console.log('ERROR', e, r.statusText);
//       if (r.ok) {
//         throw new Error('errors.something_wrong');
//       }
//       throw new Error(r.statusText);
//     }))
//   .then((res) => {
//     if (res.status === 'success') {
//       return res.data;
//     }
//     throw new Error(res.data.error || 'errors.something_wrong');
//   });
//
// export default {
//   api,
//   get: (path, body) => api(`${path}?${params(body)}`, 'GET'),
//   post: (path, body) => api(path, 'POST', { body: JSON.stringify(body) }),
//   put: (path, body) => api(path, 'PUT', { body: JSON.stringify(body) }),
//   delete: (path, body) => api(`${path}?${params(body)}`, 'DELETE'),
// };
